import React, { useEffect, useCallback } from 'react';

import { useAuth } from '../../context/authContext';
import { DownloadItem } from '../../components/addUrlDownloads';
import { getDownloadWidgets } from '../../utils/fixedWidgets';
import { Widget } from '../UserGroupsPage';
import UsergroupBar from '../../components/UsergroupBar';
import FilterDownloadWidgets from '../../components/FilterUsergroupWidgets';

import { Container, Card, CardHeader, CardContent } from '../../components/ui';
import {
  FileListContainer,
  FileItemContainer,
  FileButton,
  FileCheckbox,
  ButtonsContainer,
  ActionButton,
  LoadingText,
  NoFilesText,
  PageTitle,
} from './styles';

const DownloadFilesPage: React.FC = () => {
  const [downloadItems, setDownloadItems] = React.useState<DownloadItem[]>([]);
  const [selectedFiles, setSelectedFiles] = React.useState<DownloadItem[]>([]);
  const [selectedWidgets, setSelectedWidgets] = React.useState<Widget[]>();

  const [showWidgetsSelect, setShowWidgetSelect] =
    React.useState<boolean>(false);

  const handleDownloadAll = (): void => {
    let timeout = 1200;
    downloadItems.forEach(file => {
      const link = document.createElement('a');
      link.href = decodeURI(file.url);
      // link.target = '_blank';
      link.download = file.description;
      setTimeout(() => {
        // console.log('clicking', link);
        link.click();
      }, timeout);
      timeout += 1200;
    });
  };

  const handleDownloadSelected = (): void => {
    let timeout = 1200;
    selectedFiles.forEach(file => {
      const link = document.createElement('a');
      link.href = decodeURI(`${file.url}?filename=${file.description}`);
      // link.target = '_blank';
      link.download = file.description;
      setTimeout(() => {
        link.click();
      }, timeout);
      timeout += 1200;
    });
  };

  const handleSelectFile = (file: DownloadItem, isChecked: boolean): any => {
    if (isChecked) {
      setSelectedFiles(prevSelected => [...prevSelected, file]);
    } else {
      setSelectedFiles(prevSelected => prevSelected.filter(f => f !== file));
    }
  };

  // selectedFiles.forEach(file => {
  //   console.log('selectedFiles', file);
  // });

  const handleButtonClick = (file: DownloadItem): void => {
    const wasChecked = selectedFiles.some(x => x === file);
    const isChecked = !wasChecked;
    handleSelectFile(file, isChecked);
  };

  const { user } = useAuth();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const urlParams = new URLSearchParams(window.location.search);
  const selectedId = Number(urlParams.get('id')) ?? undefined;

  const findDownloadWidgets = useCallback(
    (widgetsList: Widget[]): Widget[] => {
      return getDownloadWidgets(widgetsList, selectedId);
    },
    [selectedId],
  );

  useEffect(() => {
    if (!user.selectedUsergroup) return;
    setIsLoading(true);

    const allDownloadWidgets = findDownloadWidgets(
      user.selectedUsergroup.settings.widgets.children,
    );

    setSelectedWidgets(allDownloadWidgets);
    setIsLoading(false);
  }, [findDownloadWidgets, user.selectedUsergroup]);

  useEffect(() => {
    // show selected (if filtering) or all download widgets

    const widgets =
      selectedWidgets ??
      getDownloadWidgets(user?.selectedUsergroup?.settings?.widgets.children);

    if (widgets.length > 1) {
      setShowWidgetSelect(true);
    }
    console.log({ widgets });
    setDownloadItems(
      widgets
        ? widgets.flatMap((widget: Widget) => widget.downloadItens ?? [])
        : [],
    );
  }, [selectedWidgets, user?.selectedUsergroup?.settings?.widgets]);

  return (
    <>
      <UsergroupBar
        barContent={
          showWidgetsSelect && (
            <FilterDownloadWidgets setSelectedWidgets={setSelectedWidgets} />
          )
        }
        onChangeUsergroup={() => {
          urlParams.delete('id');
          window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${urlParams}`,
          );
          setSelectedFiles([]);
        }}
      >
        <Container maxWidth="full" padding>
          <Card variant="elevated" padding="large" fullHeight>
            <CardHeader>
              <PageTitle>Downloads</PageTitle>
            </CardHeader>

            <CardContent>
              {isLoading && <LoadingText>Loading...</LoadingText>}
              {!isLoading && downloadItems.length === 0 && (
                <NoFilesText>No files to download</NoFilesText>
              )}

              <FileListContainer>
                {downloadItems.map((file, index) => {
                  return (
                    <FileItemContainer key={index}>
                      <FileButton onClick={() => handleButtonClick(file)}>
                        <FileCheckbox
                          checked={selectedFiles.some(x => x === file)}
                          onChange={() => console.log('')} // do not remove
                        />
                        {file.description}
                      </FileButton>
                    </FileItemContainer>
                  );
                })}

                {selectedFiles.length > 0 ? (
                  <ButtonsContainer>
                    <ActionButton onClick={handleDownloadSelected}>
                      Download Selected
                    </ActionButton>
                  </ButtonsContainer>
                ) : (
                  !isLoading &&
                  downloadItems.length > 0 && (
                    <ButtonsContainer>
                      <ActionButton onClick={handleDownloadAll}>
                        Download All
                      </ActionButton>
                    </ButtonsContainer>
                  )
                )}
              </FileListContainer>
            </CardContent>
          </Card>
        </Container>
      </UsergroupBar>
    </>
  );
};

export default DownloadFilesPage;
